import { GENDER, USER_STATES } from '../constants';
import * as ActionTypes from './type';

const defaultState = {
  userState: USER_STATES.applicantLookUp,
  prevUserState: null,
  creditLimit: 0,
  maxDrawdownAmount: 0,
  minDrawdownAmount: 0,
  totalCreditLimit: 0,
  loanAmount: 0,
  loanId: 0,
  fromAddressDetailsPage: false,

  selectedEmiPlan: {
    loanAmount: 0,
    tenureInMonths: 0,
    rateOfInterest: 0,
    emi: 0,
    repayableAmount: 0,
    emiStartDate: '',
    processingFee: 0,
  },
  usersPersonalDetails: {
    fullName: '',
    dob: '',
    gender: GENDER.Male,
    pan: '',
  },
};

export function creditLine(state = defaultState, action) {
  const {
    type,
    userState,
    creditLimit,
    maxDrawdownAmount,
    minDrawdownAmount,
    totalCreditLimit,
    loanAmount,
    selectedEmiPlan,
    usersPersonalDetails,
    partner,
    creditLine,
    loanId,
    fromAddressDetailsPage,
  } = action;

  switch (type) {
    case ActionTypes.SET_USER_STATE:
      return { ...state, prevUserState: state.userState, userState };

    case ActionTypes.SET_CREDIT_LIMIT:
      return {
        ...state,
        creditLimit,
        maxDrawdownAmount,
        minDrawdownAmount,
        totalCreditLimit,
      };

    case ActionTypes.SET_LOAN_AMOUNT:
      return { ...state, loanAmount };

    case ActionTypes.SET_EMI_PLAN:
      return { ...state, selectedEmiPlan };

    case ActionTypes.SET_PERSONAL_DETAILS:
      return { ...state, usersPersonalDetails };

    case ActionTypes.SET_BANK_PARTNER:
      return { ...state, partner };

    case ActionTypes.SET_CREDIT_LINE_STATE:
      return { ...state, ...creditLine };

    case ActionTypes.SET_CREDIT_LINE_LOAN_ID:
      return { ...state, loanId };

    case ActionTypes.FROM_ADDRESS_DETAIL_PAGE:
      return { ...state, fromAddressDetailsPage };

    default:
      return state;
  }
}
